var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"text-align":"center"}},[(_vm.planesPlacedOnSheet)?_c('div',{ref:"capture",attrs:{"id":"svg_area"},domProps:{"innerHTML":_vm._s(_vm.sheetSVG)}}):_vm._e(),(_vm.planesPlacedOnSheet)?_c('a',{attrs:{"href":_vm.sheetPNG,"download":"plansa-avioanele-ro.png"}},[_vm._v("Descarcă planșa (PNG)")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }